module.exports = __webpack_public_path__ + "static/media/selected.ca048aee.svg";